import { Input } from '@/components/ui/input';
import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { useProfileActions } from '../store/store';
import { useEffect, useRef, useState } from 'react';
import { ProfilesTableData } from './profile-table';

export function ProfilesTable() {
  return (
    <div className="col-span-12">
      <ProfilesTableSearch />
      <ProfilesTableData />
    </div>
  );
}

export function ProfilesTableSearch() {
  const { setSearchTerm } = useProfileActions();
  const [search, setSearch] = useState('');
  const lastTermRef = useRef<string | null>(null);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (search !== lastTermRef.current) {
        setSearchTerm(search);
        lastTermRef.current = search;
      }
    }, 500);
    return () => {
      clearTimeout(delayDebounce);
    };
  }, [search, setSearchTerm]);

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 pb-4">
      <div className="col-span-6 sm:col-span-12 sm:w-[320px] w-full">
        <div className="relative">
          <MagnifyingGlassIcon className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            placeholder="Search..."
            value={search}
            onChange={(event) => {
              setSearch(event.target.value);
            }}
            className="bg-background w-full rounded-lg pl-9"
          />
        </div>
      </div>
    </div>
  );
}
